// Browser file downloads + CSV building, shared by every surface that exports.
//
// Kept in one place because the anchor dance has a real footgun: the anchor MUST
// be in the document when `.click()` fires — a detached one is silently a no-op
// in some browsers — so a hand-rolled copy tends to look right and do nothing.

/** Hand `blob` to the browser as a file download named `filename`. */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** One RFC-4180 CSV field: always quoted, and prefixed with an apostrophe when
 *  the value opens with something a spreadsheet would evaluate. Exported text
 *  (survey comments, ticket subjects) can originate from anonymous senders, so a
 *  CSV must never be able to run a formula when the admin opens it. */
export function csvField(v: unknown): string {
  const s = v == null ? "" : String(v);
  const safe = /^[=+\-@\t\r]/.test(s) ? `'${s}` : s;
  return `"${safe.replace(/"/g, '""')}"`;
}

/** A CSV blob from rows of raw values. BOM-prefixed so Excel reads it as UTF-8. */
export function csvBlob(rows: unknown[][]): Blob {
  const body = rows.map((r) => r.map(csvField).join(",")).join("\r\n");
  return new Blob(["\ufeff" + body], { type: "text/csv;charset=utf-8" });
}
